export let VIDEO_CARDS_ORIENTATIONS;
(function (VIDEO_CARDS_ORIENTATIONS) {
  VIDEO_CARDS_ORIENTATIONS[VIDEO_CARDS_ORIENTATIONS["VERTICAL"] = 1] = "VERTICAL";
  VIDEO_CARDS_ORIENTATIONS[VIDEO_CARDS_ORIENTATIONS["HORIZONTAL"] = 2] = "HORIZONTAL";
})(VIDEO_CARDS_ORIENTATIONS || (VIDEO_CARDS_ORIENTATIONS = {}));
//# sourceMappingURL=orientations.js.map